const lang = {
    ja: {
        'faq.pageTitle': 'よくあるご質問',
        'faq.visitorFAQ': '入場者向けよくあるご質問',
        'faq.organizerFAQ': '出展者向けよくあるご質問',
        'faq.viewer': '入場者向け{text}',
        'faq.organizer': '出展者向け{text}',
    },
    en: {
        'faq.pageTitle': 'FAQ',
        'faq.visitorFAQ': 'FAQ for attendees',
        'faq.organizerFAQ': 'FAQ for exhibitors',
        'faq.viewer': '{text} for attendees',
        'faq.organizer': '{text} for exhibitors',
    },
};

export default lang;
